import React, {Component} from "react";

import style from './_modal.module.scss';
import Checkbox from "../Checkbox";

import Row from "../Layout/Row";
import ElementModal from "./ElementModal";
import Column from "../Layout/Column";
let classNames = require('classnames');

export default class BuildingModal extends Component {
	state = {
	};

	static getDerivedStateFromProps(props, state) {
		if(props.building && !state.name) {
			let {id, name, address, city, devices} = props.building;
			return {
				id, name, address, city, devices
			}
		}  else return null;
	}

	reset = () => {
		this.setState({
			id: undefined,
			name: undefined,
			address: undefined,
			city: undefined,
			devices: undefined
		})
	};

	submit = () => {
		let {id, name, address, city, devices} = this.state;
		if(!name) {
			this.setState({error: "Specifica il nome dell'edificio"});
			return;
		}
		let building = {
			id,
			name,
			address,
			city,
			devices: devices ? devices.map(d => d.deviceId) : null
		};
		this.reset();
		this.props.onSubmit(building);
	};

	close = () => {
		this.reset()
		this.props.onClose()
	}

	render() {

		let {isOpen, unassigned} = this.props;
		let assignables = [];
		if(this.props.devices) assignables = assignables.concat(this.props.devices);
		if(unassigned) assignables = assignables.concat(unassigned);
		let className = classNames([style.modal, style.newUserModal]);

		return (
			<ElementModal isOpen={isOpen} onClose={this.close} className={className} error={this.state.error} reset={this.reset} submit={this.submit}>
				<Row className={style.fields}>
					<Column>
						<input
							type={"text"}
							placeholder={"Nome Edificio"}
							onChange={(e) => this.setState({name:e.target.value})}
							value={this.state.name}
						/>
					</Column>
					<Column>

					</Column>
				</Row>
				<Row className={style.fields}>
					<Column>
						<input type={"text"} placeholder={"Indirizzo"} onChange={(e) => this.setState({address:e.target.value})} value={this.state.address}/>
					</Column>
					<Column>
						<input type={"text"} placeholder={"Città"} onChange={(e) => this.setState({city:e.target.value})} value={this.state.city}/>
					</Column>
				</Row>
						<Row>
						<Column className={style.section}>
							<div className={style.title}>Dispositivi Disponibili</div>
							{
								assignables.map(device =>
									<Row key={device.id}>
										<Checkbox
											checked={this.state.devices && !!this.state.devices.find(d => d.id === device.id)}
											onCheck={() => {
												let devices = this.state.devices;
												if(!devices)
													this.setState({devices:[device]});
												else if(devices.find(d => d.id === device.id))
													this.setState({devices: devices.filter(d => d.id !== device.id)});
												else {
													devices.push(device);
													this.setState({devices});
												}
											}}
										/>
											{device.label || device.deviceId}
									</Row>
								)
							}
						</Column>
						</Row>

			</ElementModal>
		);
	}
}